var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12zM11 17.297a.867.867 0 0 1-.868-.869v-3.56h-3.56A.867.867 0 0 1 5.703 12a.867.867 0 0 1 .869-.868h3.56v-3.56A.867.867 0 0 1 11 6.703c.48 0 .868.388.868.869v3.56h3.56a.867.867 0 1 1 0 1.736h-3.56v3.56a.884.884 0 0 1-.868.869"
})));
export default SvgAddTag;